export default __webpack_public_path__ + "static/media/veluwe-specialist.b41c1ddd.png";